<div *ngIf="form" [formGroup]="form">
  <div [ngSwitch]="question.controlType" *ngIf="!question.hide">
    <mat-form-field *ngSwitchCase="'textarea'" appearance="fill">
      <mat-label
        >{{ question.label }}
        <span class="text-danger" *ngIf="question.required">*</span>
      </mat-label>
      <textarea
        [id]="question.key"
        [type]="question.type"
        placeholder="{{ question.placeholder }}"
        matInput
        [maxlength]="question.maxLength"
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="5"
        [formControlName]="question.key"
        [style.height.px]="question.minHeight"
      ></textarea>
      <button
        class="btn btn-copy-to-clipboard"
        type="button"
        (click)="copyToClipboard(question)"
        matSuffix
        *ngIf="question.copyToClipboard"
        matTooltip="{{ 'Copy ' + question.label }}"
        matTooltipPosition="above"
        matTooltipClass="copy-to-clipboard-tooltip"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
      <mat-error *ngFor="let error of question.errors">
        <mat-error *ngIf="form.hasError(error.key, question.key)" [innerHTML]="error.message"> </mat-error>
      </mat-error>
    </mat-form-field>

    <div *ngSwitchCase="'checkbox'">
      <div class="file-input-wrapper">
        <div class="file-input-inner-wrapper">
          <mat-checkbox [id]="question.key" [formControlName]="question.key" [(ngModel)]="question.value"
            >{{ question.label }}
            <span class="text-danger" *ngIf="question.required">*</span>
          </mat-checkbox>
          <mat-error *ngFor="let error of question.errors">
            <mat-error *ngIf="form.hasError(error.key, question.key)" [innerHTML]="error.message"> </mat-error>
          </mat-error>
        </div>
      </div>
    </div>

    <mat-form-field *ngSwitchCase="'textbox'" appearance="fill">
      <mat-label
        >{{ question.label }}
        <span class="text-danger" *ngIf="question.required">*</span>
      </mat-label>
      <div
        [matTooltip]="null | applyFunctionOrValue: getInputTooltip"
        [matTooltipDisabled]="!this.question.disabled && this.control.enabled"
        matTooltipClass="custom-tooltip"
        [style.display]="question.type === 'password' ? 'flex' : ''"
      >
        <input
          matInput
          placeholder="{{ question.placeholder }}"
          [id]="question.key"
          [type]="question.type !== 'password' ? question.type : question.hidePassword ? 'password' : 'text'"
          [formControlName]="question.key"
        />
        <mat-icon *ngIf="question.iconTooltipText" matSuffix class="info-icon" [matTooltip]="question.iconTooltipText"
          >info</mat-icon
        >
        <button
          *ngIf="question.type === 'password'"
          type="button"
          mat-icon-button
          matSuffix
          (click)="question.hidePassword = !question.hidePassword"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="question.hidePassword"
        >
          <mat-icon class="green-icon">{{ question.hidePassword ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
      </div>
      <mat-error *ngFor="let error of question.errors">
        <mat-error *ngIf="form.hasError(error.key, question.key)" [innerHTML]="error.message"> </mat-error>
      </mat-error>
      <button
        class="btn btn-copy-to-clipboard"
        type="button"
        (click)="copyToClipboard(question)"
        matSuffix
        *ngIf="question.copyToClipboard"
        matTooltip="{{ 'Copy ' + question.label }}"
        matTooltipPosition="above"
        matTooltipClass="copy-to-clipboard-tooltip"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field *ngSwitchCase="'dropdown'" appearance="fill">
      <mat-label>
        {{ question.label }}
        <span class="text-danger" *ngIf="question.required">*</span>
      </mat-label>
      <div
        [matTooltip]="tooltipMessage"
        matTooltipClass="custom-tooltip"
        [matTooltipDisabled]="!this.question.disabled && this.control.enabled"
      >
        <mat-select
          [id]="question.key"
          [formControlName]="question.key"
          (selectionChange)="onChange($event)"
          #dropdownQuestion
        >
          <mat-option *ngIf="question.search?.filter && !question.disabled">
            <ngx-mat-select-search
              [formControl]="searchControl"
              [searching]="question.search.loading"
              placeholderLabel="Search"
              [noEntriesFoundLabel]="
                !question.search.hideNoEntriesFoundLabel &&
                !(question.addNewEntry && !question.addNewEntry.hidden) &&
                'No entry matches'
              "
            >
            </ngx-mat-select-search>
          </mat-option>
          <!-- HACK: Use "hidden" attribute for showNullOption to allow button type elements to be displayed -->
          <mat-option [hidden]="!question.showNullOption" [value]="null">None</mat-option>
          <mat-option *ngFor="let opt of question.options" [value]="opt.value" [disabled]="opt.disabled">
            {{ opt.label }}
          </mat-option>
          <button
            *ngIf="question.addNewEntry && !question.addNewEntry.hidden"
            class="mat-option"
            type="button"
            mat-icon-button
            matSuffix
            (click)="question.addNewEntry.action(form, question); dropdownQuestion.close()"
          >
            + Create New
          </button>
        </mat-select>
        <mat-icon *ngIf="question.iconTooltipText" matSuffix class="info-icon" [matTooltip]="question.iconTooltipText"
          >info</mat-icon
        >
      </div>
      <button
        class="btn btn-copy-to-clipboard"
        type="button"
        matSuffix
        (click)="copyDropDownToClipboard($event, question, select.selected)"
        *ngIf="question.copyToClipboard"
        matTooltip="{{ 'Copy ' + question.label }}"
        matTooltipPosition="above"
        matTooltipClass="copy-to-clipboard-tooltip"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
      <mat-error *ngFor="let error of question.errors">
        <mat-error *ngIf="form.hasError(error.key, question.key)" [innerHTML]="error.message"> </mat-error>
      </mat-error>
    </mat-form-field>
    <label *ngSwitchCase="'radio'" class="example-radio-label">{{ question.label }}</label>
    <mat-radio-group *ngSwitchCase="'radio'" [formControlName]="question.key" class="example-radio-group">
      <mat-radio-button class="example-radio-button" *ngFor="let opt of question.options" [value]="opt.value">
        {{ opt.label }}
      </mat-radio-button>
      <mat-error *ngFor="let error of question.errors">
        <mat-error *ngIf="form.hasError(error.key, question.key)" [innerHTML]="error.message"> </mat-error>
      </mat-error>
    </mat-radio-group>

    <mat-form-field *ngSwitchCase="'date'" appearance="fill">
      <mat-label
        >{{ question.label }}
        <span class="text-danger" *ngIf="question.required">*</span>
      </mat-label>
      <input
        matInput
        (dateChange)="dateChange($event, question.key)"
        [matDatepicker]="datePicker"
        [min]="question.minDate"
        [max]="question.maxDate"
        [formControlName]="question.key"
        (click)="datePicker.open()"
        autocomplete="off"
      />
      <mat-icon *ngIf="question.iconTooltipText" matSuffix class="info-icon" [matTooltip]="question.iconTooltipText"
        >info</mat-icon
      >
      <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
      <mat-datepicker color="primary" #datePicker></mat-datepicker>
      <button
        class="btn btn-copy-to-clipboard"
        type="button"
        (click)="copyDateToClipboard(question)"
        matSuffix
        *ngIf="question.copyToClipboard"
        matTooltip="{{ 'Copy ' + question.label }}"
        matTooltipPosition="above"
        matTooltipClass="copy-to-clipboard-tooltip"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
      <mat-error *ngFor="let error of question.errors">
        <mat-error *ngIf="form.hasError(error.key, question.key)" [innerHTML]="error.message"> </mat-error>
      </mat-error>
    </mat-form-field>

    <div *ngSwitchCase="'file'" class="form-group">
      <!-- TODO: Add required handling and error display -->
      <div class="file-input-wrapper">
        <div *ngIf="question.onlyShowUploadButton" class="file-input-inner-wrapper">
          <mat-hint> {{ chipList?.length }} file(s) selected.</mat-hint>
          <ngx-mat-file-input
            [formControlName]="question.key"
            [disabled]="!!question.disabled"
            [accept]="question.fileOptions?.accept || '*'"
            [multiple]="!!question.fileOptions?.multiple"
          >
            <!-- <mat-icon ngxMatFileInputIcon>folder</mat-icon> -->
          </ngx-mat-file-input>
        </div>
        <mat-form-field *ngIf="!question.onlyShowUploadButton" appearance="fill">
          <ngx-mat-file-input
            [formControlName]="question.key"
            [disabled]="!!question.disabled"
            [accept]="!!question.fileOptions && !!question.fileOptions.accept ? question.fileOptions.accept : '*'"
            [multiple]="
              !!question.fileOptions && !!question.fileOptions.multiple ? question.fileOptions.multiple : false
            "
          >
            <!-- <mat-icon ngxMatFileInputIcon>folder</mat-icon> -->
          </ngx-mat-file-input>
          <mat-icon *ngIf="question.iconTooltipText" matSuffix class="info-icon" [matTooltip]="question.iconTooltipText"
            >info</mat-icon
          >
        </mat-form-field>
      </div>
      <mat-chip-list class="mat-chip-list-stacked">
        <mat-chip *ngFor="let chip of chipList; let i = index" selected>
          <span class="ellipsis"> ({{ i + 1 }}) {{ chipLabel(chip) }}</span>
          <mat-icon class="clearBtn" (click)="removeChip(chip)">clear</mat-icon>
        </mat-chip>
      </mat-chip-list>
      <mat-error *ngFor="let error of question.errors">
        <mat-error *ngIf="form.hasError(error.key, question.key)" [innerHTML]="error.message"> </mat-error>
      </mat-error>
    </div>
    <mat-form-field *ngSwitchCase="'number'" appearance="fill">
      <mat-label
        >{{ question.label }}
        <span class="text-danger" *ngIf="question.required">*</span>
      </mat-label>
      <input
        matInput
        placeholder="{{ question.placeholder }}"
        [disabled]="question.disabled"
        [id]="question.key"
        [min]="question.minValue"
        [step]="question.step"
        [type]="question.type"
        [formControlName]="question.key"
      />
      <mat-icon *ngIf="question.iconTooltipText" matSuffix class="info-icon" [matTooltip]="question.iconTooltipText"
        >info</mat-icon
      >
      <span *ngIf="question.isCurrency" matPrefix>$&nbsp;</span>
      <button
        class="btn btn-copy-to-clipboard"
        type="button"
        (click)="copyToClipboard(question)"
        matSuffix
        *ngIf="question.copyToClipboard"
        matTooltip="{{ 'Copy ' + question.label }}"
        matTooltipPosition="above"
        matTooltipClass="copy-to-clipboard-tooltip"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
      <mat-error *ngFor="let error of question.errors">
        <mat-error *ngIf="form.hasError(error.key, question.key)" [innerHTML]="error.message"> </mat-error>
      </mat-error>
    </mat-form-field>
    <mat-form-field *ngSwitchCase="'link'" appearance="fill">
      <mat-label
        >{{ question.label }}
        <span class="text-danger" *ngIf="question.required">*</span>
      </mat-label>
      <div>
        <input
          matInput
          placeholder="{{ question.placeholder }}"
          [disabled]="question.disabled"
          [id]="question.key"
          readonly
          [formControlName]="question.key"
        />
      </div>

      <button
        class="btn btn-copy-to-clipboard"
        type="button"
        (click)="redirect(question.link)"
        matSuffix
        *ngIf="question.copyToClipboard"
        matTooltip="{{ 'Open ' + question.label }}"
        matTooltipPosition="above"
        matTooltipClass="copy-to-clipboard-tooltip"
      >
        <mat-icon>link</mat-icon>
      </button>

      <button
        class="btn btn-copy-to-clipboard"
        type="button"
        (click)="copyToClipboard(question)"
        matSuffix
        *ngIf="question.copyToClipboard"
        matTooltip="{{ 'Copy ' + question.label }}"
        matTooltipPosition="above"
        matTooltipClass="copy-to-clipboard-tooltip"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
    </mat-form-field>
    <div *ngSwitchCase="'image'" class="form-group">
      <div [ngClass]="question.delete?.show ? 'delete-image' : ''">
        <mat-form-field
          [ngClass]="{ pointer: form.enabled }"
          appearance="fill"
          (click)="form.enabled && fileInput.click()"
        >
          <mat-label
            >{{ question.label }}
            <span class="text-danger" *ngIf="question.required">*</span>
          </mat-label>
          <input
            readonly
            [disabled]="!form.enabled"
            [ngClass]="{ pointer: form.enabled }"
            type="text"
            matInput
            value="{{ question.value || (form.enabled && question.imageReqs.imageName) ? 'Yes' : 'No' }}"
          />
          <input
            hidden
            (change)="onFileSelected($event)"
            accept="image/png, image/jpg, image/jpeg"
            #fileInput
            type="file"
          />
          <mat-icon
            matSuffix
            [ngStyle]="form.disabled && { opacity: 0.5 }"
            [ngClass]="{ 'icon-disabled': form.disabled }"
          >
            upload</mat-icon
          >
        </mat-form-field>
        <div (click)="$event.preventDefault()">
          <ng-container *ngIf="question.delete?.show && control?.value && form.disabled">
            <button mat-icon-button (click)="question.delete.callback()" style="bottom: 9px">
              <mat-icon matPreffix>delete</mat-icon>
            </button>
          </ng-container>
          <ng-container *ngIf="question.delete?.show && form.enabled">
            <button
              mat-icon-button
              (click)="question.delete.callback()"
              style="bottom: 9px"
              [disabled]="!control?.value"
            >
              <mat-icon matPreffix>delete</mat-icon>
            </button>
          </ng-container>
        </div>
      </div>
      <div class="form-group text-center">
        <img class="img-fluid" #partnerImage width="150px" *ngIf="control?.value" [src]="control.value" />
      </div>
      <mat-error *ngIf="question.imageReqs.fileTooBig">
        File too large (Max size
        {{ question.imageReqs.fileRestrictions.maxSize / 1000 }}KB)
      </mat-error>
      <mat-error *ngIf="question.imageReqs.invalidDimensions">
        File dimensions too large (Max size
        {{ question.imageReqs.fileRestrictions.maxWidth }}x{{ question.imageReqs.fileRestrictions.maxHeight }}px)
      </mat-error>
    </div>
  </div>
</div>
